export const REQUEST_UPDATE_PUSH_API_SUBSCRIPTION = 'REQUEST_UPDATE_PUSH_API_SUBSCRIPTION';
export const UPDATE_PUSH_API_REPORT_SUCCESS = 'UPDATE_PUSH_API_REPORT_SUCCESS';
export const UPDATE_PUSH_API_REPORT_ERROR = 'UPDATE_PUSH_API_REPORT_ERROR';
export const FETCH_PUSH_API_REPORT_FOR_EDIT_ERROR = 'FETCH_PUSH_API_REPORT_FOR_EDIT_ERROR';
export const DELETE_PUSH_API_REPORT_SUCCESS = 'DELETE_PUSH_API_REPORT_SUCCESS';
export const DELETE_PUSH_API_REPORT_ERROR = 'DELETE_PUSH_API_REPORT_ERROR';
